import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import "@/style/idec/font.css";
// import "@/style/idec/style2.css";
// import "@/style/idec/ui.css";
// import "@/style/adlock/style.css";
// import "@/style/adlock/queries.css";
Vue.config.productionTip = false;
// import "@/assets/css/webflow.css";

// import "@/style/hellocaria/style.css";
// import "@/style/hellocaria/main.css";
// import "@/style/hellocaria/more.css";
// import "swiper/dist/css/swiper.css";

import "@/style/bluebird/common.css";
import "@/style/bluebird/296f04f8749a2ff8c64a.css";
import "@/style/bluebird/49199623a358498a800d.css";
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
